<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['Campanha', 'Data Criação', 'Data Envio', 'Canal', 'Modelo', 'Lista', 'Situação', 'Enviados', 'Não Enviados', $lang.Common.DataTable.Actions]"
            :showNew="true"
            :showSearch="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.nome ? obj.nome.toUpperCase() : ''" />
        <TableColumn :IsDatetime="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.dataCriacao" />
        <TableColumn :IsDatetime="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.dataEnvio" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="onGetPlatform(obj.plataforma)" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.campanhaModelo ? obj.campanhaModelo.nome : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.campanhaLista ? obj.campanhaLista.nome : ''" />
        <TableColumn :IsCustom="true">
          <b-badge variant="primary" v-if="obj.situacao <= 1">PENDENTE</b-badge>
          <b-badge variant="success" v-else-if="obj.situacao === 2">ENVIANDO</b-badge>
          <b-badge variant="secondary" v-else-if="obj.situacao === 3">ENVIADO</b-badge>
          <b-badge variant="secondary" v-else-if="obj.situacao === 4">CONCLUÍDO</b-badge>
        </TableColumn>
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.enviados ? obj.enviados.toString() : '0'" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.falhas ? obj.falhas.toString() : '0'" />
        <TableColumn :IsCustom="true"  :status="obj.inative ? 0 : 1">
          <a href="javascript:void(0);" class="mr-2" v-if="obj.iniciada" @click.prevent="onStop(obj)"><i class="fas fa-stop text-danger" style="font-size: 16px" v-b-tooltip.hover :title="'Parar Envio agora!'"></i></a>
          <a href="javascript:void(0);" class="mr-2" v-else @click.prevent="onStart(obj)"><i class="fas fa-play text-third" style="font-size: 16px" v-b-tooltip.hover :title="'Iniciar Envio agora!'"></i></a>
          <a href="javascript:void(0);" class="mr-2" @click="onOpenSendTest(obj)"><i class="fas fa-paper-plane text-third" style="font-size: 16px" v-b-tooltip.hover :title="'Testar Envio'"></i></a>
          <a href="javascript:void(0);" class="mr-2" @click.prevent="$emit('Report', obj)"><i class="fas fa-chart-line text-third" style="font-size: 18px" v-b-tooltip.hover :title="'Visualizar Resultados'"></i></a>
          <b-dropdown variant="link" size="sm" no-caret>
            <template slot="button-content">
              <i class="fa fa-trash icone-grid text-third"  v-b-tooltip.hover :title="'Excluir'" style="display: block;position: relative;top: -4px;"></i><span class="sr-only">{{$lang.Common.Buttons.Delete}}</span>
            </template>
            <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
            <b-dropdown-item href="javascript:void(0);" v-on:click="onDelete(obj)">{{$lang.Common.Yes}}</b-dropdown-item>
            <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
          </b-dropdown>
        </TableColumn>
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'"><i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo</span></button>
      </div>
    </div>
    <ModalSendTest
      ref="ModalSendTest"
    />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ModalSendTest from './modal/emailtestmodal/ModalSendTest.vue'
import CampaignRepository from '@/shared/http/repositories/campaign/campaign.js'
import SearchScreen from '../search/search.vue'

export default {
  name: 'CampaignList',
  components: {
    ModalSendTest
  },
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        let optionFilters = ''
        if (this.filters.nome) {
          optionFilters += `nome=${this.filters.nome}&`
        }
        if (this.filters.tipo) {
          optionFilters += `tipo=${this.filters.tipo}&`
        }
        CampaignRepository.Search(optionFilters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      } else {
        CampaignRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      }
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      CampaignRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onStart (obj) {
      loading.push()
      CampaignRepository.Start(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onStop (obj) {
      loading.push()
      CampaignRepository.Stop(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onShowSearch () {
      let aside = {
        title: 'Pesquisar',
        self: this,
        component: SearchScreen
      }
      this.$eventHub.emit('Search', aside)
    },
    onGetPlatform (typeTemplate) {
      let result = ''
      if (typeTemplate) {
        switch (parseInt(typeTemplate)) {
          case 1: result = 'E-MAIL'
            break
          case 2: result = 'SMS'
            break
          case 3: result = 'WHATSAPP'
            break
        }
      }
      return result
    },
    onOpenSendTest (campanha) {
      this.$refs.ModalSendTest.showModal(campanha)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/campaign/components/list/campainglist.vue